import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import PublicNavbar from './PublicNavbar';
import PublicFooter from './PublicFooter';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
  overflow: hidden;
`;

const ScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: ${props => props.theme.background};
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  /* Custom Scrollbar - Discord Theme */
  &::-webkit-scrollbar {
    width: 16px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.scrollbarTrack};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.scrollbarThumb};
    border-radius: 8px;
    border: 4px solid ${props => props.theme.scrollbarTrack};
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${props => props.theme.scrollbarThumbHover};
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${props => props.theme.scrollbarThumb} ${props => props.theme.scrollbarTrack};
`;

const PageContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const PublicLayout = () => {
  const { pathname } = useLocation();
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [pathname]);

  return (
    <LayoutContainer>
      <PublicNavbar />
      <ScrollContainer ref={scrollRef}>
        <PageContent>
          <Outlet />
        </PageContent>
        <PublicFooter />
      </ScrollContainer>
    </LayoutContainer>
  );
};

export default PublicLayout;
